export * from "./formatHotkey"
export * from "./Menu"
export * from "./MenuItem"

/**
 * Menu is shared between different components like:
 *
 * - toolbar
 * - table dialogs
 */
